__turbopack_context__.v({
  "userPlanPremium": "styles-module-scss-module__IEkDJG__userPlanPremium",
  "userPlanPro": "styles-module-scss-module__IEkDJG__userPlanPro",
  "userPlanStarter": "styles-module-scss-module__IEkDJG__userPlanStarter",
  "userPlanTag": "styles-module-scss-module__IEkDJG__userPlanTag",
});
